/*
Sohel 01/31/2023 2701334326 added request Letter Functionality
Prakash 10-05-23 2701334326 add theme class name.
*/
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import React, {useContext} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
const stopLetterDropdown = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];
const StopLetter = (props) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {values, handleChange, errors, handleBlur, touched, setFieldValue} = props;

  const overRideOption = [
    {key: 'A', value: 'A - Account'},
    {key: 'S', value: 'S - Seed'},
    {key: 'R', value: 'R - Route'},
  ];

  return (
    <Grid container spacing={4} className="new-standard-textfields m-0">
      <Grid item xs={4} className={`form-group ${classes.selectField}`}>
        <FormControl margin="dense" variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            fullWidth
            name="applyTo"
            className={` select-gender ${classes.labelName}`}
            required
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched?.applyTo}
            error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {overRideOption.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors && errors.applyTo}</FormHelperText>
      </Grid>
      <Grid item xs={4} className={`form-group`}>
        <GuiAutoComplete
          classes={{
            option: classes.option,
          }}
          name="stopPL95"
          id="stopPL95"
          size="small"
          options={stopLetterDropdown}
          onBlur={handleBlur}
          required
          value={values?.stopPL95 || 'none'}
          getOptionDisabled={(option) => option.key === 'none'}
          getOptionLabel={(option) => {
            return option?.value ? option?.value : '';
          }}
          onChange={(e, value) => {
            setFieldValue('stopPL95', value);
          }}
          renderInput={(params) => (
            <div className="select-field">
              <GuiTextField
                {...params}
                className={` ${classes.labelName}`}
                variant="outlined"
                margin="dense"
                required
                InputLabelProps={{shrink: true}}
                label="Stop PL95"
                placeholder="Select Stop PL95"
                touched={touched?.stopPL95}
                error={Boolean(touched?.stopPL95 && errors?.stopPL95)}
              />
            </div>
          )}
        />
        <FormHelperText>{touched?.stopPL95 && errors && errors.stopPL95}</FormHelperText>
      </Grid>
      <Grid item xs={4} className={`form-group `}>
        <GuiAutoComplete
          classes={{
            option: classes.option,
          }}
          name="stopCheckWriter"
          id="stopCheckWriter"
          size="small"
          options={stopLetterDropdown}
          onBlur={handleBlur}
          required
          value={values?.stopCheckWriter || 'none'}
          getOptionDisabled={(option) => option.key === 'none'}
          getOptionLabel={(option) => {
            return option?.value ? option?.value : '';
          }}
          onChange={(e, value) => {
            setFieldValue('stopCheckWriter', value);
          }}
          renderInput={(params) => (
            <div className="select-field">
              <GuiTextField
                {...params}
                className={` ${classes.labelName}`}
                variant="outlined"
                margin="dense"
                required
                InputLabelProps={{shrink: true}}
                label="Stop Check Writer"
                placeholder="Select Stop Check Writer"
                touched={touched?.stopCheckWriter}
                error={Boolean(touched?.stopCheckWriter && errors?.stopCheckWriter)}
              />
            </div>
          )}
        />
        <FormHelperText>
          {touched?.stopCheckWriter && errors && errors.stopCheckWriter}
        </FormHelperText>
      </Grid>
    </Grid>
  );
};
export default StopLetter;
